import { render, staticRenderFns } from "./CombinationTile.vue?vue&type=template&id=e3da827e&scoped=true&"
import script from "./CombinationTile.vue?vue&type=script&lang=js&"
export * from "./CombinationTile.vue?vue&type=script&lang=js&"
import style0 from "./CombinationTile.vue?vue&type=style&index=0&id=e3da827e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3da827e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VRow})
